import React from 'react';

import { CONTACT_US_INFO_TYPE } from 'features/order-tracker/utils/entries/contactUsInfoType';

import { KCI2_ASSURE_APPOINTMENT_MESSAGE } from './constants';

import styles from './styles.module.scss';

export const AmendAndContactUsInfo: React.FC<components.AmendAndContactUsInfo> = ({
  type,
  isAmendAppointmentEnabled,
}) => {
  const getInfoBlock = () => {
    if (!isAmendAppointmentEnabled) {
      return <p className={styles.amendMessageTitle}>Amending your appointment</p>;
    }
    switch (type) {
      case CONTACT_US_INFO_TYPE.Kci2Assure: {
        return <p>{KCI2_ASSURE_APPOINTMENT_MESSAGE}</p>;
      }
      case CONTACT_US_INFO_TYPE.AlreadyAmended: {
        return <></>;
      }
      case CONTACT_US_INFO_TYPE.AmendmentDisabled: {
        return <></>;
      }
      case CONTACT_US_INFO_TYPE.ForbidToAmend: {
        return <></>;
      }
      default: {
        return null;
      }
    }
  };

  return <div className={styles.infoContainer}>{getInfoBlock()}</div>;
};
